<div class="no-items-message" *ngIf="isShow">
    <span class="no-items-message__text">{{ messageTranslateKey | translate}}</span>
</div>
